import React from 'react';
import { default as BaseLink } from '@components/Link';

const Link: React.FC = (props) => {
    return <BaseLink {...props} target="_blank" />;
};

export default Link;
